export default __webpack_public_path__ + "static/media/recipesnow.c016591f.png";